module.exports = {
	"currencyType": "All prices are shown in __currencyType__",
	"description": "With the basic subscription level you can publish your auction events and have your business listed in our seller directory, you are however limited in the number of lots you can publish and the amount of pictures you can upload per lot . You can remove these limitations by upgrading to a premium seller account.",
	"free": "Free",
	"header": "Subscription pricing",
	"headerSmall": "$t(general::brand) seller subscription",
	"basic": {
		"description": "You can publish your auctions and business listed in the directory.",
		"item1": "Auctions and business listed in the directory.",
		"item2": "Up to __maxLots__ lots per auction.",
		"item3": "Limit of __maxPictures__ picture per lot."
	},
	"premium": {
		"description": "A premium subscription allows you to publish more lots per auction and upload more pictures per lot.",
		"item1": "Displayed in featured sellers and auctions.",
		"item2": "Up to __maxLots__ lots per auction.",
		"item3": "Limit of __maxPictures__ pictures per lot."
	}
}


//////////////////
// WEBPACK FOOTER
// /private/var/folders/n9/yczdnstj3wdc9q5tzm6d45c00000gp/T/maison-encans-auex-website/~/@auex/locales/lib/en/pricing.json5
// module id = 1955
// module chunks = 6